import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PpbLoginComponent } from '../../ppb/ppb-login/ppb-login.component';
import { BrowserCompatibilityService } from '../../shared/services/browser-compatibility.service';

@Component({
  selector: 'ppb-browser-not-supported',
  templateUrl: './browser-not-supported.component.html',
  styleUrls: ['./browser-not-supported.component.scss']
})
export class BrowserNotSupportedComponent implements OnInit {

  readonly browserCompatible: boolean;
  readonly browserOutdated: boolean;
  rulesUrl: string;

  constructor(
    private browserCompatibilityService: BrowserCompatibilityService,
    private route: ActivatedRoute
  ) {
    this.browserCompatible = this.browserCompatibilityService.isBrowserCompatible();
    this.browserOutdated = this.browserCompatibilityService.isBrowserOutdated();
  }

  ngOnInit(): void {
    this.rulesUrl = this.rulesUrlFromConfiguration();
  }

  private rulesUrlFromConfiguration(): string {
    const conf = this.route.snapshot.data.configuration;
    if (!conf || !conf.agreements || !conf.agreements.rulesUrl) {
      return PpbLoginComponent.DEFAULT_RULES_URL;
    }
    return conf.agreements.rulesUrl;
  }
}
